import { render } from "./SnoozedPage.vue?vue&type=template&id=d5aa9c72&ts=true"
import script from "./SnoozedPage.vue?vue&type=script&lang=ts"
export * from "./SnoozedPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__